/* eslint-disable no-use-before-define */
import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { Box, Checkbox, InputAdornment } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const UIComboBox = ({
  options,
  onChange,
  handleTextChange = (value) => {
    console.log(value);
  },
  loading = false,
  variant = "outlined",
  title = "Select Company Key",
  styles = {},
  editable = true,
  handleBlur = null,
  name,
  required = false,
  error,
  freeSolo = false,
  placeholder = "Select one or more...",
  prefix = "",
  //for textarea prop
  multiline = false,
  maxRows = 3,
  minRows,
  disabled = false,
  multiple = false,
  disableClearable = false,
  disableCloseOnSelect = true,
  size = "small",
  className = "",
  customLabel = false,
  value = [],
  limitTags = -1,
  chipStyles = {},
  popupIcon = <ExpandMoreIcon sx={{ fontSize: "1.2rem" }} />,
  addSelectAllOption = false,
}) => {
  const [focus, setFocus] = useState(false);
  const valueOptions = (Array.isArray(value) ? value : [])
    .map((valId) => {
      const existing = options.find((option) => option.value === valId);
      if (existing) return existing;
      if (freeSolo && valId != null && String(valId).trim() !== "") {
        return { label: String(valId), value: valId };
      }
      return null;
    })
    .filter(Boolean);

  const readOptionValue = (item) => {
    if (typeof item === "string") return item.trim();
    return item?.value;
  };

  const handleOnChange = (e, data, reason, details) => {
    e.preventDefault();
    let value = details?.option?.value ?? readOptionValue(details?.option);
    let selectedData = data
      .map(readOptionValue)
      .filter((item) => item != null && item !== "");
    // Note: if select-all option added make sure it's value should be 0
    if (addSelectAllOption && value === 0) {
      if (reason === "selectOption") {
        selectedData = options.map((opt) => opt.value);
      } else if (reason === "removeOption") {
        selectedData = [];
      }
    }

    if (
      value !== 0 &&
      selectedData.includes(0) &&
      selectedData.length !== options.length
    ) {
      selectedData = selectedData.filter((opt) => opt !== 0);
    }

    onChange({
      ...e,
      target: {
        ...e.target,
        name,
        value: selectedData ? selectedData : [],
      },
    });
  };

  const renderTags = (value, getTagProps) => {
    return value.map((option, index) => {
      // Hide the select-all chip when that option is enabled (value must be 0)
      if (addSelectAllOption && option?.value === 0) {
        return null;
      }

      return (
        <Chip
          key={option?.value ?? index}
          sx={{
            fontSize: "14px",
            ".MuiSvgIcon-root": {
              width: "18px",
              height: "18px",
            },
            ...chipStyles,
          }}
          label={
            options.find((opt) => opt.value == option.value)?.label ||
            option?.label
          }
          {...getTagProps({ index })}
        />
      );
    });
  };
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  return (
    <div className={"custom-combo-comp"} style={styles}>
      <Autocomplete
        multiple={multiple}
        limitTags={limitTags}
        disabled={disabled}
        freeSolo={freeSolo}
        required={required}
        loading={loading}
        forcePopupIcon={"auto"}
        popupIcon={popupIcon}
        onBlur={(e) => {
          setFocus(false);
          if (handleBlur) handleBlur(e);
        }}
        id="checkboxes-tags"
        options={options}
        disableCloseOnSelect={disableCloseOnSelect}
        disableClearable={disableClearable}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option?.label || ""
        }
        isOptionEqualToValue={(option, selected) =>
          readOptionValue(option) === readOptionValue(selected)
        }
        onChange={handleOnChange}
        onFocus={() => setFocus(true)}
        value={valueOptions}
        renderTags={(value, getTagProps) =>
          focus ? (
            <Box
              sx={{
                maxHeight: (theme) => theme.spacing(17),
                overflowY: "auto",
              }}
            >
              {renderTags(value, getTagProps)}
            </Box>
          ) : (
            renderTags(value, getTagProps)
          )
        }
        renderOption={(props, option, { selected }) => (
          <li {...props} style={{ padding: 0 }}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 0 }}
              checked={selected}
            />
            {option.label}
          </li>
        )}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              required={required}
              variant={variant}
              error={!!error}
              helperText={error || ""}
              label={title}
              name={name}
              inputProps={{
                ...params.inputProps,
                name,
              }}
              size={size}
              //for textarea prop
              multiline={multiline}
              maxRows={maxRows}
              minRows={minRows}
              placeholder={
                freeSolo && valueOptions.length === 0 ? placeholder : ""
              }
              sx={{
                background: disabled
                  ? "var(--palette-disabled_button)"
                  : "var(--palette-grid_table)",
              }}
              InputLabelProps={{
                style: {
                  color: error
                    ? "#d32f2f"
                    : disabled
                      ? "var(--palette-disabled_button_text)"
                      : "var(--palette-grey_text)",
                },
              }}
              // placeholder={valueOptions.length === options.length ? "All selected" : placeholder}
              {...(prefix
                ? {
                    InputProps: {
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            {prefix}
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                    },
                  }
                : {})}
            />
          );
        }}
        sx={{
          "& ,MuiAutocomplete-endAdornment": {
            "& .MuiAutocomplete-clearIndicator": {
              "& svg": {
                color: "var(--palette-text) !important",
                fill: "var(--palette-text) !important",
              },
            },
          },
        }}
      />
    </div>
  );
};

export default UIComboBox;
